import * as React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  VStack
} from "@chakra-ui/react";


interface Props {
  node: any
}


export const Information: React.FC<Props> = ( props ) => {
  return (
    <Flex
      direction={{
        base: 'column',
        lg: 'row'
      }}
      alignItems={{
        lg: 'center'
      }}
      gap={{
        base: '24px',
        lg: '100px',
        xl: '150px'
      }}
    >
      <Box
        minW={{
          lg: '400px',
          xl: '510px'
        }}
        w={{
          base: '100%',
          lg: '400px',
          xl: '510px'
        }}
      >
        { props.node.frontmatter.image &&
          <Image
            as={ GatsbyImage }
            image={ props.node.frontmatter.image.childImageSharp.gatsbyImageData }
          />
        }
        { props.node.frontmatter.heading &&
          <Heading
            as="h2"
            fontSize="48px"
            fontWeight={ 700 }
            color="text.primary"
          >
            { props.node.frontmatter.heading }
          </Heading>
        }
      </Box>
      <VStack
        justify="flex-start"
        align="flex-start"
        spacing="24px"
      >
        { props.node.frontmatter.subheading &&
          <Heading
            as="h3"
            color="text.primary"
            fontSize="36px"
            fontWeight={ 700 }
          >
            { props.node.frontmatter.subheading }
          </Heading>
        }
        { props.node.frontmatter.description &&
          <Text
            fontSize="16px"
            fontWeight={ 400 }
            color="text.secondary"
          >
            { props.node.frontmatter.description }
          </Text>
        }
      </VStack>
    </Flex>
  )
}
